(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-examine-player-wager.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-examine-player-wager.js');
"use strict";


const {
  useEffect
} = React;
const {
  getLogger
} = svs.core.log;
const {
  useExaminePlayerWagerMutation
} = svs.components.tipsen.store.tipsenApi;
const {
  useBestBetRows
} = svs.components.poolBetting.bestBetRows.hooks;
const logger = getLogger('pool-betting:use-examine-player-wager');
const MAX_RETRIES = 5;
const ONE_SECOND = 1000;
const useExaminePlayerWager = _ref => {
  let {
    examined,
    isDrawFinalized,
    productId,
    wagerId,
    drawNumber
  } = _ref;
  const [examineWagerMutation, status = {}] = useExaminePlayerWagerMutation();
  const {
    isInitialized: isMaskedOutcomesInitialized,
    maskedOutcomes
  } = useBestBetRows();
  const [retryCount, setRetryCount] = React.useState(0);
  const {
    error
  } = status;
  useEffect(() => {
    if (examined !== false || !isDrawFinalized || !drawNumber) {
      return;
    }
    if (isMaskedOutcomesInitialized && maskedOutcomes.length === 0) {
      if (retryCount >= MAX_RETRIES) {
        logger.error("Examine wager failed after ".concat(MAX_RETRIES, " retries"));
        logger.error('Error message:', error === null || error === void 0 ? void 0 : error.message);
        return;
      }
      const retryWithDelay = setTimeout(async () => {
        try {
          await examineWagerMutation({
            productId,
            wagerId,
            drawNumber
          }).unwrap();
          setRetryCount(0);
        } catch (err) {
          logger.warn('Examine wager failed:', err === null || err === void 0 ? void 0 : err.message);
          setRetryCount(prevCount => prevCount + 1);
        }
      }, ONE_SECOND);
      return () => clearTimeout(retryWithDelay);
    }
  }, [drawNumber, error === null || error === void 0 ? void 0 : error.message, examineWagerMutation, examined, isDrawFinalized, isMaskedOutcomesInitialized, maskedOutcomes === null || maskedOutcomes === void 0 ? void 0 : maskedOutcomes.length, productId, retryCount, wagerId]);
};
setGlobal('svs.components.poolBetting.hooks.useExaminePlayerWager', useExaminePlayerWager);

 })(window);